import React, {FunctionComponent} from "react";
import {PropsWithOverwrite} from "../../../utils/input";
import InputRadio, {InputRadioProps} from "./InputRadio";
import FlexContent, {FlexContentAlignment, FlexContentDirection} from "../flex-content/FlexContent";

export type RadioButtonProps = PropsWithOverwrite<InputRadioProps, {
    label: string;
}>;

const RadioButton: FunctionComponent<RadioButtonProps> = ({label, ...inputAttr}) => {
    return (
        <FlexContent
            direction={FlexContentDirection.ROW}
            alignment={FlexContentAlignment.CENTER}
            cssClass="radio-button"
        >
            <InputRadio {...inputAttr}/>
            <label htmlFor={inputAttr.id}>{label}</label>
        </FlexContent>
    );
};

export default RadioButton;
